export default __webpack_public_path__ + "img/2b9c0a51f5273f700da1cc3affdc2301.png";